/**
 * Loads the FES2014 stations once at startup so the tide card can use the free
 * offline heights/streams. No data yet = empty, no error.
 */
import { useEffect } from 'react';
import { useFesStationsStore } from '@/store/fesStations';

export function FesStationsLoader() {
  const load = useFesStationsStore((s) => s.load);
  useEffect(() => {
    void load();
  }, [load]);
  return null;
}
